import { Utils } from '../utils';
const _downConvertMap = {
    'http://adlnet.gov/expapi/verbs/experienced': 'experienced',
    'http://adlnet.gov/expapi/verbs/attended': 'attended',
    'http://adlnet.gov/expapi/verbs/attempted': 'attempted',
    'http://adlnet.gov/expapi/verbs/completed': 'completed',
    'http://adlnet.gov/expapi/verbs/passed': 'passed',
    'http://adlnet.gov/expapi/verbs/failed': 'failed',
    'http://adlnet.gov/expapi/verbs/answered': 'answered',
    'http://adlnet.gov/expapi/verbs/interacted': 'interacted',
    'http://adlnet.gov/expapi/verbs/imported': 'imported',
    'http://adlnet.gov/expapi/verbs/created': 'created',
    'http://adlnet.gov/expapi/verbs/shared': 'shared',
    'http://adlnet.gov/expapi/verbs/voided': 'voided'
};
export class Verb {
    id;
    display;
    constructor(cfg) {
        this.id = '';
        this.display = {};
        this.init(cfg);
    }
    init(cfg) {
        const directProps = ['id', 'display'];
        if (typeof cfg === 'string') {
            this.id = cfg;
            this.display = {
                und: this.id
            };
            for (const prop in _downConvertMap) {
                if (_downConvertMap[prop] === cfg) {
                    this.id = prop;
                    break;
                }
            }
        }
        else {
            cfg = cfg || {};
            for (const prop of directProps) {
                if (cfg[prop]) {
                    this[prop] = cfg[prop];
                }
            }
            if (Object.keys(this.display).length === 0 && typeof _downConvertMap[this.id] !== 'undefined') {
                this.display = {
                    und: _downConvertMap[this.id]
                };
            }
        }
    }
    toString(lang) {
        if (this.display !== null) {
            return this.getLangDictionaryValue('display', lang);
        }
        return this.id;
    }
    asVersion(version = '1.0.3') {
        const { id, display } = this;
        const result = {
            id,
            display
        };
        return result;
    }
    getLangDictionaryValue = Utils.getLangDictionaryValue;
    static fromJSON(verbJSON) {
        const _verb = JSON.parse(verbJSON);
        return new Verb(_verb);
    }
}
